"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const async_1 = require("../async");
const exec_1 = require("../botones/exec");
const fastInputDelay = 500;
/**
 * Un input controlado se vuelve muy lento en android debido a que se estan actualizando constantemente sus
 * propiedades.
 *
 * Este componente envuelve a un input no controlado y solo actualiza su valor cuando es necesario, logrando
 * que se pueda escribir de manera fluida en este en móviles
 */
class FastInput extends React.Component {
    constructor() {
        super(...arguments);
        this.handleRef = (input) => {
            if (input) {
                input.addEventListener("input", this.handleOnChange, true);
                input.addEventListener("blur", this.handleBlur, true);
                input.addEventListener("focus", this.handleFocus, false);
            }
            else if (this.input) {
                this.input.removeEventListener("input", this.handleOnChange);
                this.input.removeEventListener("blur", this.handleBlur);
                this.input.removeEventListener("focus", this.handleFocus);
            }
            this.input = input;
            this.setInputValue(this.props.value || "");
        };
        this.handleFocus = (e) => {
            if (this.input) {
                this.setInputValue(this.props.value || "");
                if (this.props.selectAllOnFocus)
                    this.input.setSelectionRange(0, this.input.value.length);
            }
        };
        this.propsCount = 0;
        this.unbouncedRefresh = (value) => {
            this.propsCount++;
            const currentCount = this.propsCount;
            const currentChangeCount = this.changeCount;
            setTimeout(() => {
                if (currentCount == this.propsCount && currentChangeCount == this.changeCount) {
                    this.setInputValue(value);
                }
            }, fastInputDelay);
        };
        this.changeCount = 0;
        this.raiseOnChange = (value) => {
            if (this.props.onChange && this.lastValue !== value) {
                this.lastValue = value;
                this.props.onChange(value);
            }
        };
        this.handleOnChange = (e) => {
            this.changeCount++;
            const currentCount = this.changeCount;
            this.inputValue = this.input.value;
            setTimeout(() => {
                if (currentCount == this.changeCount) {
                    this.raiseOnChange(e.target.value);
                }
            }, fastInputDelay);
        };
        this.handleBlur = (e) => {
            this.propsCount++;
            this.changeCount++;
            if (this.input) {
                this.raiseOnChange(this.inputValue);
            }
        };
        this.handleKeyPress = async (ev) => {
            if (ev.key == "Enter") {
                this.propsCount++;
                this.changeCount++;
                if (this.input) {
                    this.raiseOnChange(this.inputValue);
                }
                await async_1.delay(50);
                await exec_1.execUserFunc(this.props.onEnter);
            }
        };
    }
    componentWillReceiveProps(newProps) {
        const isFocused = this.input == document.activeElement;
        if (isFocused) {
            this.unbouncedRefresh(newProps.value);
        }
        else if (this.input) {
            this.input.value = newProps.value;
        }
    }
    /**
     * Establece el valor del input igual al valor de props.value
     * @param value Nuevo valor
     */
    setInputValue(value) {
        if (this.input && this.input.value != value) {
            this.input.value = value;
        }
    }
    render() {
        const props = this.props.onChange ?
            Object.assign({}, this.props, { value: undefined, onChange: undefined }) :
            Object.assign({}, this.props);
        const elementType = this.props.multiline ? "textarea" : "input";
        //Quitamos los props que no le pertenecen al textarea ni al input
        const { multiline, selectAllOnFocus, onEnter } = props, newProps = __rest(props, ["multiline", "selectAllOnFocus", "onEnter"]);
        const ref = (this.props.onChange && this.handleRef);
        const element = React.createElement(elementType, Object.assign({ ref }, newProps, { onKeyPress: this.handleKeyPress }));
        return element;
    }
}
exports.FastInput = FastInput;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/fields/fastInput.js
// module id = 2208
// module chunks = 0